import { z } from 'zod';
export const projectsPortalProjectSummaryCapability = 'projects.portal-project-summary.v1';
export const projectsPortalProjectSummaryProviderId = 'projects.server.portal-project-summary';
export const projectsPortalProjectSummaryGrant = 'projects.portal-summary.read';
export const projectsPortalProjectSummaryRequestSchema = z.strictObject({
    projectId: z.string().uuid(),
});
export const projectsPortalProjectSummarySchema = z.strictObject({
    projectId: z.string().uuid(),
    projectNumber: z.string().min(1).max(80),
    name: z.string().min(1).max(240),
    status: z.string().min(1).max(80),
    customerDisplayName: z.string().max(240).nullable(),
    serviceAddress: z.strictObject({
        line1: z.string().max(240).nullable(),
        line2: z.string().max(240).nullable(),
        city: z.string().max(120).nullable(),
        region: z.string().max(120).nullable(),
        postalCode: z.string().max(40).nullable(),
        countryCode: z.string().regex(/^[A-Z]{2}$/),
    }),
    sourceRevision: z.number().int().positive(),
    sourceUpdatedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=projects-portal-project-summary.contract.js.map